export const plugins = {
    enabled: false,
};
